module.exports = __webpack_public_path__ + "img/MXN.de3bbb88.svg";